import type { FactFamilyId, FactId, Operation } from "./model.ts";

function pad(value: number): string {
  return String(value).padStart(2, "0");
}

export function positiveFamilyId(a: number, b: number, c: number): FactFamilyId {
  return `R20.FAMILY.${pad(a)}.${pad(b)}.${pad(c)}`;
}

export function factId(
  operation: Operation,
  left: number,
  right: number,
  answer: number,
): FactId {
  return `R20.FACT.${operation}.${pad(left)}.${pad(right)}.${pad(answer)}`;
}
